import { createSlice } from "@reduxjs/toolkit";
import { defaultData } from "../../_helper/Constant";

const initialState = {
  loading: false,
  defaultPrinter: defaultData,
  printerList: [defaultData],
  error: null
};

const printerSlice = createSlice({
  name: "printer",
  initialState,
  reducers: {
    removePrinterData: (state, action) => {
      state.defaultPrinter = null;
      state.printerList = null;
    },
    OnLoadingprinter: (state, action) => {
      state.loading = true;
      state.printerList = [];
    },
    OnSuccessprinter: (state, action) => {
      state.printerList = action.payload;
      state.loading = false;
    },
    setPrinter: (state, action) => {
      state.defaultPrinter = action.payload;
      state.loading = false;
    },
    OnFailureprinter: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { OnFailureprinter, OnSuccessprinter, OnLoadingprinter, setPrinter, removePrinterData } =
  printerSlice.actions;

export const getSelectedprinterList = (state) => state.printer.printerList;
export const getSelectedDefaultPrinter = (state) => state.printer.defaultPrinter;
export default printerSlice.reducer;
